// removed by extract-text-webpack-plugin
module.exports = {"signTable":"_1OJOTJm0RH8CIh-vDz8vy2","editable":"f5B5WDGX5knW8oCKP_Jnw","signValue":"_2UvmzDnaPiX2LcAW523gkd","forbiddenSignValue":"_3gDqC8JXd-CBXDHYF7NvC8","forbiddenValue":"_20NkcvKuUOeYOaj2LAXM5K","forbiddenValueSwitch":"_3CPdMmnBFn7z48u7NZ2cpv","signRow":"_1jKCDZf7U3UgXib5yA0Qn_","signColumn":"eyWaTGAcUnz-ys2FfP-mG"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Quiz/QuizSignAndVariationsTable.scss
// module id = 971
// module chunks = 0